export const SUBDOMAIN_REGEX = '^[^\\-][A-Za-z0-9\\-]*[^\\-]';

/**
 * Basic email regex, guards against two dots together, dot at beginning or end of local part or domain
 */
export const EMAIL_REGEX =
  '^[\\w%+\\-]+(\\.[\\w%+\\-]+)*@[A-Za-z0-9\\-]+(\\.[A-Za-z0-9\\-]+)*\\.[A-Za-z]{2,}$';
